import { render, staticRenderFns } from "./doc-type-avatars.vue?vue&type=template&id=f7b74e9e&scoped=true&"
import script from "./doc-type-avatars.vue?vue&type=script&lang=js&"
export * from "./doc-type-avatars.vue?vue&type=script&lang=js&"
import style0 from "./doc-type-avatars.vue?vue&type=style&index=0&id=f7b74e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b74e9e",
  null
  
)

export default component.exports